<template>
  <v-alert
    id="alert"
    color="#C51162"
    dark
    icon="mdi-alert-circle"
    border="left"
    prominent
    :value="!!error.message"
    transition="fade-transition"
    dismissible
    dense
    @input="hide"
    class="zind"
  >
    <v-expansion-panels class="min-h">
      <v-expansion-panel>
        <v-expansion-panel-header>{{ error.name }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          {{ error.message }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-alert>
</template>

<script setup lang="ts">
import store from '@/store'
import { computed } from 'vue';
const error = computed(() => store.getters.error)
const hide = () => store.commit('clearError')
</script>
<style lang="sass">
.zind
  z-index: 999!important
.min-h
  min-width: 290px!important
#alert
  position: fixed
  min-width: 300px
  bottom: 20px
  right: 10px
.theme--dark.v-expansion-panels .v-expansion-panel
  background-color: rgba(0, 0, 0, 0) !important
</style>
